import Timer from '@common/components/timer';
import React, { useMemo, useContext } from 'react';
import { useTranslation } from '@common/hooks/translation';
import MoneyAmount from '@common/components/moneyAmount';
import Config from '@app/dev/config/main';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import { getCurrencyConfig, normalizeAmount } from '../helper';
import { HandleStartFinish } from '@app/dev/helpers/clientTransaction';

export const UserInactivity = ({ amount, loading, onContinue, onDeposit, onTimeout, onClose }) => {
  const t = useTranslation();
  const [{ openPopup }] = useContext(PopupContext);
  const currencyConfig = useMemo(() => getCurrencyConfig(), []);
  const numericAmount = normalizeAmount(amount);

  return (
    <>
      {onClose && numericAmount <= 0 && (
        <i onClick={onClose} className="global-icon icon-Close close-popup" />
      )}
      <p className="popup-title">{t('Deposit Timeout')}</p>
      <div className="popup-main-content deposit-section-container">
        <p className="text-center">
          {t('You have inserted')}{' '}
          <span className="highlighted-amount">
            <MoneyAmount
              config={Config}
              amount={numericAmount}
              currencyConfig={currencyConfig}
            />
          </span>{' '}
          {t('You have been inactive. Your deposit will be automatically completed in:')}
        </p>
        <div className="timer-container">
          <Timer
            variant="round"
            duration={10}
            onFinish={() => {
              const currentAmount = normalizeAmount(amount);
              if (currentAmount > 0) {
                onTimeout?.();
              } else {
                console.log("================mtav")
                HandleStartFinish.finish();
                openPopup(POPUPS.CLIENT_DEPOSIT_FAIL_POPUP);
              }
            }}
          />
        </div>
        <div className="popup-actions dual-buttons">
          <button
            type="button"
            className="popup-cancel-button"
            onClick={onContinue}
            disabled={loading}
          >
            {t('continue')}
          </button>
          <button
            type="button"
            className="popup-confirm-button"
            onClick={onDeposit}
            disabled={loading}
          >
            {t('deposit')}
          </button>
        </div>
      </div>
    </>
  );
};
